/** Values of the survey loading preview's `?scenario=` control. */
export const SURVEY_LOADING_SCENARIOS = [
  "offline",
  "recovered",
  "serverError",
  "malformed",
  "notFound",
  "gone",
  "expired",
  "completed",
  "empty",
  "success",
] as const;

export type SurveyLoadingScenario = (typeof SURVEY_LOADING_SCENARIOS)[number];

/** The scenario shown when `?scenario=` is absent or invalid. */
export const DEFAULT_SURVEY_LOADING_SCENARIO: SurveyLoadingScenario = "offline";
